import { Button, Card } from "@ptsd/uikit";
import { Anchor, Text, useMedia, View } from "tamagui";

export const PaymentInfoScreen = ({
  title,
  text,
  icon,
  disabled,
}: {
  text: string;
  title: string;
  disabled?: boolean;
  icon?: React.ReactNode;
}) => {
  const { sm } = useMedia();
  return (
    <Card
      variant={sm ? "borderless" : "default"}
      maxWidth={486}
      margin={"$20"}
      padding={"$2.2"}
      $gtSm={{
        margin: "$10",
        padding: "$5.2",
      }}
      alignSelf="center"
      gap={"$3"}
    >
      <View
        margin={"24"}
        flex={1}
        alignItems={"center"}
        justifyContent={"center"}
      >
        {icon}
      </View>
      <View width={"100%"} gap={"$2"}>
        <Text
          fontFamily={"$subtitle"}
          fontWeight={"600"}
          fontSize={24}
          textAlign={"center"}
        >
          {title}
        </Text>
        <Text
          fontFamily={"$subtitle"}
          fontSize={16}
          lineHeight={22}
          textAlign={"center"}
          color={"$gray-600"}
        >
          {text}
        </Text>
        <View marginTop={"$3"}>
          <Anchor href={"/results/hmt"} disabled={disabled} asChild={true}>
            <Button
              disabled={disabled}
              variant={"primary"}
              size={"lg"}
              rounded={"lg"}
            >
              Далі
            </Button>
          </Anchor>
        </View>
      </View>
    </Card>
  );
};
